export default __webpack_public_path__ + "static/media/Google_playstore_01.0ec15cee.svg";